@if (clientSettingsForm) {
    <div [formGroup]="clientSettingsForm" class="widget-settings d-sm-flex flex-column">
    <h3>General Settings</h3>
    <div class="d-sm-flex flex-column">
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" placeholder="Enter chatbot name">
            @if (clientSettingsForm.get('name')?.invalid && clientSettingsForm.get('name')?.touched) {
                <mat-error>
                    Name is required
                </mat-error>
            }
        </mat-form-field>
        <mat-slide-toggle formControlName="enabled">Enabled</mat-slide-toggle>
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description" placeholder="Enter description" rows="4"></textarea>
            @if (clientSettingsForm.get('description')?.invalid && clientSettingsForm.get('description')?.touched) {
                <mat-error>
                    Description is required
                </mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Image</mat-label>
            <input matInput formControlName="image" placeholder="Enter url for image">
            @if (clientSettingsForm.get('image')?.invalid && clientSettingsForm.get('image')?.touched) {
                <mat-error>
                    Image url is required
                </mat-error>
            }
            @if (clientSettingsForm.get('image')?.hasError('pattern') && clientSettingsForm.get('image')?.touched) {
                <mat-error>
                    Enter a valid URL (must start with http:// or https://)
                </mat-error>
            }
        </mat-form-field>
    </div>
    </div>
}
